import { render, staticRenderFns } from "./titleBox.vue?vue&type=template&id=c872364c&scoped=true&"
import script from "./titleBox.vue?vue&type=script&lang=js&"
export * from "./titleBox.vue?vue&type=script&lang=js&"
import style0 from "./titleBox.vue?vue&type=style&index=0&id=c872364c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c872364c",
  null
  
)

export default component.exports